module.exports = __webpack_public_path__ + "img/step1.12069703.png";